import React from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_cozy-stitches-15/artifacts/gdxyro16_tgs_logo_tp.png";

export const Hero = () => {
  const { count, setIsOpen } = useCart();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className="relative w-full"
      style={{ backgroundColor: "var(--bg-primary)" }}
    >
      {/* Top bar */}
      <div className="absolute top-0 left-0 right-0 flex items-center justify-between px-6 py-5 md:px-12">
        <span
          className="font-script text-xl md:text-2xl"
          style={{ color: "var(--brand-sage)" }}
          data-testid="brand-wordmark"
        >
          The Giving Stitch
        </span>
        <button
          onClick={() => setIsOpen(true)}
          className="relative flex items-center gap-2 rounded-full px-4 py-2 transition-colors"
          style={{
            backgroundColor: "#fff",
            border: "1px solid var(--border-soft)",
            color: "var(--text-primary)",
          }}
          data-testid="open-cart-button"
          aria-label="Open cart"
        >
          <ShoppingBag size={18} />
          <span className="text-sm font-medium hidden sm:inline">Cart</span>
          {count > 0 && (
            <span
              className="absolute -top-2 -right-2 flex h-6 min-w-6 items-center justify-center rounded-full px-1.5 text-xs font-semibold text-white"
              style={{ backgroundColor: "var(--brand-orange)" }}
              data-testid="cart-count-badge"
            >
              {count}
            </span>
          )}
        </button>
      </div>

      <div className="flex flex-col items-center px-6 pt-24 pb-12 md:pt-28 md:pb-20">
        <img
          src={LOGO_URL}
          alt="The Giving Stitch — Handmade Plushies & Crochet Creations"
          className="w-full max-w-[420px] md:max-w-[520px] h-auto animate-soft-in"
          data-testid="hero-logo"
        />

        <div
          className="mt-2 flex items-center gap-3 tracking-[0.35em] text-xs uppercase"
          style={{ color: "var(--text-secondary)" }}
          data-testid="hero-est-tagline"
        >
          <span
            className="h-px w-10"
            style={{ backgroundColor: "var(--border-soft)" }}
          />
          Est. 2026
          <span
            className="h-px w-10"
            style={{ backgroundColor: "var(--border-soft)" }}
          />
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <button
            onClick={() => scrollTo("ready-to-ship")}
            className="btn-sage px-7 py-3 rounded-full text-sm font-semibold tracking-wide uppercase"
            data-testid="hero-shop-button"
          >
            Shop Ready to Ship
          </button>
        </div>
      </div>
    </header>
  );
};

export default Hero;
